"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _swrConfig = require("./swrConfig");
Object.keys(_swrConfig).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _swrConfig[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _swrConfig[key];
        }
    });
});
var _topArea = require("./topArea");
Object.keys(_topArea).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _topArea[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _topArea[key];
        }
    });
}); //# sourceMappingURL=index.js.map
